// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#shu-booking-form .discount-code-input__toggle-wrapper{text-align:right}#shu-booking-form .discount-code-input__trigger{font-size:0.9em;color:inherit;display:inline-block}#shu-booking-form .discount-code__note{font-weight:200;margin-top:0.5em}\n", ""]);
// Exports
module.exports = exports;
